/**
 * HomePage — the public landing page. Pure composition: each <Home*> section
 * owns its own state, animations, and copy. Add or reorder sections here.
 */
import { HomeArcadeEngine } from './sections/HomeArcadeEngine';
import { HomeCTA } from './sections/HomeCTA';
import { HomeDirections } from './sections/HomeDirections';
import { HomeHero } from './sections/HomeHero';
import { HomePricingPreview } from './sections/HomePricingPreview';
import { HomeTapToAsk } from './sections/HomeTapToAsk';
import { HomeThreeModes } from './sections/HomeThreeModes';
import { HomeUGC } from './sections/HomeUGC';
import { HomeVocabEngine } from './sections/HomeVocabEngine';

export function HomePage(): JSX.Element {
  return (
    <div className="relative">
      <HomeHero />
      <HomeArcadeEngine />
      <HomeThreeModes />
      <HomeTapToAsk />
      <HomeUGC />
      <HomeVocabEngine />
      <HomeDirections />
      <HomePricingPreview />
      <HomeCTA />
    </div>
  );
}
